import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  IGetBaseLLMTemplateDTO,
  IGetBaseLLMTemplateResponse,
  IUpdateBaseLLMTemplateDTO,
  IUpdateBaseLLMTemplateResponse,
} from '@/models/llmTemplate.model';
import { IApiError } from '@/models/apiError.model';
import { formatApiError } from '@/utils';
import { LLMTemplateAPI } from '@/api';
import { SLICE_NAME } from './models';

export const getBaseTemplateByType = createAsyncThunk<
  IGetBaseLLMTemplateResponse,
  IGetBaseLLMTemplateDTO,
  { serializedErrorType: IApiError }
>(
  `${SLICE_NAME}/getBaseTemplateByType`,
  async (params) => {
    const response = await LLMTemplateAPI.getBaseTemplate(params);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const updateBaseTemplate = createAsyncThunk<
  IUpdateBaseLLMTemplateResponse,
  IUpdateBaseLLMTemplateDTO,
  { serializedErrorType: IApiError }
>(
  `${SLICE_NAME}/updateBaseTemplate`,
  async (data) => {
    const response = await LLMTemplateAPI.updateBaseTemplate(data);
    return response.data;
  },
  { serializeError: formatApiError },
);
